import { render, staticRenderFns } from "./MyIncaMetrics.vue?vue&type=template&id=f1df7862&scoped=true"
import script from "./MyIncaMetrics.vue?vue&type=script&lang=js"
export * from "./MyIncaMetrics.vue?vue&type=script&lang=js"
import style0 from "./MyIncaMetrics.vue?vue&type=style&index=0&id=f1df7862&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1df7862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1df7862')) {
      api.createRecord('f1df7862', component.options)
    } else {
      api.reload('f1df7862', component.options)
    }
    module.hot.accept("./MyIncaMetrics.vue?vue&type=template&id=f1df7862&scoped=true", function () {
      api.rerender('f1df7862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/home_page/MyIncaMetrics.vue"
export default component.exports